export default "__VITE_ASSET__0TMmB4GL__"